export const pools = [
  {
    pid: 0,
    stakedTokenName: "KYOKO",
    stakedTokenSymbol: "KYOKO",
    rewardTokenName:"KYOKO",
    stakedTokenDecimals: 18,
    tokenAddress: "0x14a32f050FACF226Ec60882398A9BF36d91DBaC2",
    poolAddress: "0x87Ba0Db3f5A28c829f32C7561268e04177367D9C",
    getUrl:"https://app.uniswap.org/#/swap?outputCurrency=0x14a32f050facf226ec60882398a9bf36d91dbac2&chain=mainnet",
    weight: 0.033,
    toFixed: 2
  },
  {
    pid: 1,
    stakedTokenName: "KYOKO:USDT LP",
    stakedTokenSymbol: "KYOKO:USDT LP",
    rewardTokenName:"KYOKO",
    stakedTokenDecimals: 18,
    tokenAddress: "0x83eEF420C54B1B8D6FeF17625ca08e19E3eb1096",
    poolAddress: "0x78fcf2Af781dcF9c0f640185a133C2289528941A",
    getUrl:"https://v2.info.uniswap.org/token/0x14a32f050facf226ec60882398a9bf36d91dbac2",
    weight: 0.967,
    toFixed: 6
  },
];
